import React from 'react';
import { Form } from 'antd';
import { usePreviousStrict } from 'util/component';
import { FormWithFieldConfigsContext } from '../../context/index';
import RenderGroup from './RenderGroup';

const RenderForm = ({ className }) => {
  const {
    patchedFields,
    initialValues,
    fields,
    groupFields,
    FIELD_PROVIDER,
    layout = 'vertical',
  } = React.useContext(FormWithFieldConfigsContext);

  const [form] = Form.useForm();
  // TODO: Will update if need handles OnValuesChange.
  const [currentFields] = React.useState(fields);
  const [value, setValue] = React.useState(initialValues);
  const previousValue = usePreviousStrict(value);
  // const previousFields = usePreviousStrict(currentFields);

  return (
    <Form
      className={className}
      form={form}
      initialValues={initialValues}
      layout={layout}
      onValuesChange={(_, values) => setValue(values)}>
      <RenderGroup
        meta={{
          FIELD_PROVIDER,
          form,
          fields: currentFields,
          previousFormValue: previousValue,
          formValue: form.getFieldsValue(),
        }}
        groupedFields={groupFields(
          patchedFields.map((patch) => {
            return patch({
              FIELD_PROVIDER,
              form,
              fields: currentFields,
              previousFormValue: previousValue,
              formValue: form.getFieldsValue(),
            });
          })
        )}
      />
    </Form>
  );
};

export default RenderForm;
